import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import AccountBtn from '../AccountBtn/AccountBtn';
import { IconAccount, IconBackArrow, IconHeart, IconCheck } from '../Icons';
import { StyledMobileNavWrapper, ParentUl, ChildBottomLinksUl, ChildMenuWrapper, StyledTopList, ChildUl, StyledLi, StyledImageWrapper, StyledChildTitle, StyledNavBreak, StyledNavBreakLi, StyledBackButton } from './MobileNavStyles';

var _ref = React.createElement(StyledNavBreakLi, null);

var _ref2 = React.createElement(
  StyledLi,
  null,
  React.createElement(
    'a',
    { href: '/account' },
    'My Account',
    React.createElement(IconAccount, null)
  )
);

var _ref3 = React.createElement(IconHeart, null);

var _ref4 = React.createElement(IconAccount, null);

var _ref5 = React.createElement(
  StyledLi,
  null,
  React.createElement(
    'a',
    { href: '/pages/college-dorm-apartment-checklist' },
    'Dorm Checklist',
    React.createElement(IconCheck, { stroke: '#221f20' })
  )
);

var _ref6 = React.createElement(StyledNavBreak, null);

var _ref7 = React.createElement(IconBackArrow, null);

var MobileNav = function MobileNav(props) {
  var _useState = useState({
    title: '',
    topLinks: [],
    bottomLinks: [],
    active: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      childMenu = _useState2[0],
      setChildMenu = _useState2[1];

  useEffect(function () {
    if (props.isNavOpen === false) {
      setChildMenu(function (childMenu) {
        return Object.assign({}, childMenu, {
          active: false
        });
      });
    }
  }, [props.isNavOpen]);

  var toggleChildMenu = function toggleChildMenu(parent) {
    var title = parent && parent.title ? parent.title : childMenu.title;
    var topLinks = parent && parent.topLinks ? parent.topLinks : childMenu.topLinks;
    var bottomLinks = parent && parent.bottomLinks ? parent.bottomLinks : childMenu.bottomLinks;
    setChildMenu({
      title: title,
      topLinks: topLinks,
      bottomLinks: bottomLinks,
      active: !childMenu.active
    });
  };

  var handleAccountBtnClick = function handleAccountBtnClick(e) {
    e.preventDefault();
    props.toggleMobileNav();
    props.toggleAccountModal({ active: true, formType: 'LOGIN' });
  };
  var handleWishlistBtnClick = function handleWishlistBtnClick(e) {
    e.preventDefault();
    window._swat.notepad.openNotepad();
    props.toggleMobileNav();
  };

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      StyledMobileNavWrapper,
      { isNavOpen: props.isNavOpen },
      React.createElement(
        'div',
        { className: 'mobile-nav-parent' },
        React.createElement(
          ParentUl,
          { childMenuActive: childMenu.active },
          props.mainMenu.linklist && props.mainMenu.linklist.map(function (navItem, ind) {
            return React.createElement(
              StyledLi,
              {
                key: navItem.title,
                lastChild: ind === props.mainMenu.linklist.length - 1
              },
              navItem.bottomLinks.length ? React.createElement(
                'button',
                { onClick: function onClick() {
                    return toggleChildMenu(navItem);
                  } },
                navItem.title
              ) : React.createElement(
                'a',
                { href: navItem.url },
                navItem.title
              )
            );
          }),
          _ref,
          props.customerLoggedIn ? React.createElement(
            Fragment,
            null,
            _ref2,
            React.createElement(
              StyledLi,
              null,
              React.createElement(
                'button',
                { onClick: function onClick(e) {
                    return handleWishlistBtnClick(e);
                  } },
                'Wishlist',
                _ref3
              )
            )
          ) : React.createElement(
            StyledLi,
            null,
            React.createElement(
              'button',
              { onClick: function onClick(e) {
                  return handleAccountBtnClick(e);
                } },
              'My Account',
              _ref4
            )
          ),
          _ref5
        ),
        React.createElement(
          ChildMenuWrapper,
          { childMenuActive: childMenu.active },
          React.createElement(
            StyledTopList,
            null,
            childMenu.topLinks && childMenu.topLinks.map(function (navItem) {
              return React.createElement(
                StyledLi,
                { key: navItem.title },
                React.createElement(
                  'a',
                  { href: navItem.url },
                  navItem.title
                )
              );
            })
          ),
          _ref6,
          React.createElement(
            StyledChildTitle,
            null,
            childMenu.title
          ),
          React.createElement(
            ChildUl,
            null,
            /* childMenu.bottomLinks.length === 1
             ? props.mainMenu.mobileImages.map(item => (
                 <StyledImageWrapper key={item.title} href={item.url}>
                   <Image src={item.image} alt={item.title} />
                   <p>
                     {item.title}
                     <IconBackArrow />
                   </p>
                 </StyledImageWrapper>
               ))
             :  */
            childMenu.bottomLinks.map(function (column, ind) {
              return React.createElement(
                ChildBottomLinksUl,
                { key: column.title, first: ind === 0 },
                column.links.map(function (navItem, i) {
                  return React.createElement(
                    StyledLi,
                    { key: navItem.title, header: i === 0 },
                    React.createElement(
                      'a',
                      { href: navItem.url },
                      navItem.title
                    )
                  );
                })
              );
            })
          )
        )
      )
    ),
    props.isNavOpen && React.createElement(
      StyledBackButton,
      {
        'aria-label': 'Mobile Nav Back Button',
        active: childMenu.active,
        onClick: function onClick() {
          return toggleChildMenu();
        }
      },
      _ref7
    )
  );
};

MobileNav.propTypes = {
  isNavOpen: PropTypes.bool.isRequired,
  mainMenuLinklist: PropTypes.array,
  mainMenu: PropTypes.object,
  customerLoggedIn: PropTypes.bool.isRequired,
  toggleMobileNav: PropTypes.func.isRequired,
  toggleAccountModal: PropTypes.func.isRequired
};

export default MobileNav;